import React, { useState } from "react";
import { Link } from 'react-router-dom';
import BgImage from "../../images/practiceArea/agreement.jpeg";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch("https://formspree.io/f/mkgoyzwk", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      alert("Message sent successfully!");
      setFormData({ name: "", email: "", message: "" });
    } else {
      alert("Failed to send message.");
    }
  };

  return (
    <div className="bg-gray-100 min-h-screen">
      {/* Header */}
      <header className="relative h-[400px] md:h-[450px] flex items-center justify-center text-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(5, 33, 55, 0.9), rgba(5, 33, 55, 0.9)), url(${BgImage})`,
        }}>
        <div>
          <h1 className="text-4xl font-bold text-white">Contact LawBeron Legals</h1>
          <p className="mt-2 text-lg text-white">We're here to help. Get in touch with us today.</p>
        </div>
      </header>

      {/* Contact Section */}
      <section className="max-w-6xl mx-auto py-12 px-6">
        <div className="grid md:grid-cols-2 gap-10">
          {/* Contact Form */}
          <div className="bg-white shadow-lg rounded-lg p-6">
            <h2 className="text-2xl font-semibold text-blue-900 mb-4">Send Us a Message</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-gray-700 font-medium">Full Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full border border-gray-300 rounded-lg p-3 mt-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter your name"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full border border-gray-300 rounded-lg p-3 mt-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter your email"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium">Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="4"
                  className="w-full border border-gray-300 rounded-lg p-3 mt-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Write your message here..."
                />
              </div>
              <button
                type="submit"
                className="w-full bg-blue-900 text-white py-3 rounded-lg font-semibold hover:bg-blue-800 transition duration-300"
              >
                Send Message
              </button>
            </form>
          </div>

          {/* Contact Information */}
          <div className="bg-white shadow-lg rounded-lg p-6">
            <h2 className="text-2xl font-semibold text-blue-900 mb-4">Our Contact Details</h2>
            <p className="text-gray-700">Reach out to us via any of the following methods:</p>
            <div className="mt-4 space-y-4">
              <p className="flex items-center text-gray-700">
                📍 <span className="ml-2">No. 12 Thomas Laniyan Street, Anthony, Lagos State</span>
              </p>
              <p className="flex items-center text-gray-700">
                📞 <span className="ml-2">+234-9025525239</span>
              </p>
              <p className="flex items-center text-gray-700">
                ✉️ <span className="ml-2">info@lawberonlegals.com</span>
              </p>
            </div>
            <h2 className="text-xl font-semibold text-blue-900 mt-6">Office Hours</h2>
            <p className="text-gray-700">Monday - Friday: 9 AM - 5 PM</p>
            <p className="text-gray-700">Saturday: 10 AM - 2 PM</p>
            <p className="text-gray-700">Sunday: Closed</p>
          </div>
        </div>
      </section>

      {/* Google Maps */}
      <section className="max-w-6xl mx-auto py-12 px-6">
        <h2 className="text-2xl font-semibold text-blue-900 text-center mb-4">Visit Our Office</h2>
        <div className="overflow-hidden rounded-lg shadow-lg">
          <iframe
            title="LawBeron Legals Location"
            className="w-full h-80"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31102.586856532272!2d3.3792052783438276!3d6.524379450000012!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b93c309ecf2c5%3A0x5d4865ebba65b6ef!2sLagos%2C%20Nigeria!5e0!3m2!1sen!2sng!4v1699999999999"
            allowFullScreen
            loading="lazy"
          ></iframe>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-blue-900 text-white py-12 text-center">
        <h2 className="text-3xl font-semibold">Need Legal Assistance?</h2>
        <p className="mt-2 text-lg">Book a consultation with our expert lawyers.</p>
        <button className="mt-6 bg-white text-blue-900 px-6 py-3 font-semibold rounded-lg shadow-lg">
          <Link to="/book">Schedule a Consultation</Link>
        </button>
      </section>
    </div>
  );
};

export default Contact;
